module.exports = __webpack_public_path__ + "img/logo.05191ea9.png";